import React, { Component, createRef } from 'react';
import { ArrowDropDown } from '@mui/icons-material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Grow, Paper, Popper, MenuItem, MenuList, ButtonGroup, Button } from '@mui/material';

let anchorRef;

class ExtraActionButtons extends Component {
  constructor(props) {
    super();

    this.state = {
      open: false,
      selectedIndex: 0,
    };
    anchorRef = createRef();
  }

  _handleCallback = (selectedButtonKey) => {
    if (selectedButtonKey.includes('export')) {
      this.props.exportCallback(true);
    } else {
      this.props.onReportItemEvent(null, selectedButtonKey);
    }
  };

  _handleMenuItemClick = (event, index) => {
    let selectedButtonKey = this.props.buttonList[index].key;

    this.setState({ selectedIndex: index, open: false }, () =>
      this._handleCallback(selectedButtonKey)
    );
  };

  _handleToggle = () => {
    this.setState({ open: !this.state.open });
  };

  _handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };

  render() {
    let open = this.state.open;
    return (
      <div>
        <ButtonGroup
          className="u-mh-full"
          variant="contained"
          ref={anchorRef}
          aria-label="split button"
        >
          <Button
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="menu"
            onClick={this._handleToggle}
            data-qa="qa-table-expandallrows-selector"
            color="primary"
          >
            <ArrowDropDown />
          </Button>
        </ButtonGroup>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          placement={'bottom-end'}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={this._handleClose}>
                  <MenuList id="split-button-menu" autoFocusItem>
                    {this.props.buttonList.map((option, index) => (
                      <MenuItem
                        key={option.key}
                        selected={index === this.state.selectedIndex}
                        onClick={(event) => this._handleMenuItemClick(event, index)}
                        data-qa={'qa-table-' + option.key}
                      >
                        {option.name}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}

export default ExtraActionButtons;
